// Auth Zustände
export enum AuthStage {
  EMAIL_INPUT = 'EMAIL_INPUT',
  CODE_INPUT = 'CODE_INPUT',
  AUTHENTICATED = 'AUTHENTICATED'
}

// Authentifizierungsdaten
export interface AuthData {
  email: string;
  code?: string;
  isLoading: boolean;
  error?: string;
  stage: AuthStage;
}

// API Antwort Typen
export interface ApiResponse {
  success: boolean;
  message?: string;
  errorCode?: string;
}

export interface SendEmailCodeResponse extends ApiResponse {
  expiresAt?: number; // Zeitstempel für Ablauf des Codes
}

export interface VerifyCodeResponse extends ApiResponse {
}
